import { render } from "./CustumInput.vue?vue&type=template&id=3256f63e"
import script from "./CustumInput.vue?vue&type=script&lang=js"
export * from "./CustumInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__